import React, { useState } from "react"
import { StatusCode } from "../services/formService";


export const FormStatus = ({ status }: { status: StatusCode }) => {



    const StatusCodeToString = (status: StatusCode) => {
        switch (status) {
            case 1: return "Aprovado"
            case 2: return "Rejeitado";
            case 3: return "Pendente Coordenador";
            case 4: return "Finalizado";
            case 5: return "Pendente Administrador";



            default: return "Sem status";
        }
    }

    const getColor = (status: StatusCode) => {
        switch (status) {
            case 1: return "border-green-200  bg-green-100 text-green-700"
            case 2: return "border-red-200  bg-red-100 text-red-700";
            case 3: return "border-amber-200  bg-amber-100 text-amber-700";
            case 4: return "border-blue-200  bg-blue-100 text-blue-700";
            case 5: return "border-amber-300  bg-amber-100 text-amber-800";

            default: return "border-gray-200  bg-gray-100 text-gray-700";
        }
    }

    return (
        <span className={`border-2 w-min whitespace-nowrap p-1 ${getColor(status)} text-xs rounded-md`}>{StatusCodeToString(status)}</span>
    )
}